export default __webpack_public_path__ + "static/media/d6.4863fc57.jpg";